/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */

import { BrokerOrBridge, ObjectPersistence } from 'ion-types';

interface RegistryConfig {
  applicationTitle: string;
  feedbackURL?: string;
  applicationRole: string;
  isAutoUpdateAllowed: boolean;
  broker: BrokerOrBridge;
  localizedAppTitleKey: string;
  noteActionDropdownFilter: (dropdownItem: { id: string }) => boolean;
  objectPersistence: ObjectPersistence;
  thriftProtocol: Function;
  thriftTransport: Function;
  triggerLogin: Function;
  triggerLogout: Function;
}

let registryConfig: RegistryConfig;
export function configure(reg: RegistryConfig) {
  registryConfig = Object.freeze(reg);
}

export default () => registryConfig;
